module.exports = __webpack_public_path__ + "static/woman-bb-94b719223d1496ce261cfe1620bf4c66.jpg";